import React, {Component} from 'react';
import Header from "../header";
import Logo from "./../assets/img/logo.png"
import Footer from "../footer";


class AboutUs extends Component {
    render() {
        return (
            <div>
                <Header />
                <main className="aboutUs">
                    <div className="container">
                        <div className="aboutUs-container">
                            <div className="logo">
                                <img src={Logo} alt=""/>
                            </div>

                            <div className="description">
                                <h3> Saydam Pazarlama Dağıtım ve Pazarlama Hiz. Ltd. </h3>
                                <p>
                                    Saydam Dağıtım ve Pazarlama olarak 1999 senesinden itibaren Kodak İç Anadolu
                                    distribütör aracılığı ile başladığımız bu yolda Lucky kağıt kimyasalarına Türkiye
                                    distribütörlüğü ile devam ettik.

                                    2013 yılından itibaren Saydam Albüm adı altında siz değerli müşterilerimize hizmet
                                    vermekteyiz.

                                    <br/>

                                    Her zaman olduğu gibi bundan sonrada sizlere kaliteli hizmet vermeye devam edeceğiz.


                                </p>
                            </div>
                        </div>
                    </div>
                </main>
                <Footer />
            </div>
        );
    }
}

export default AboutUs;


// WEBPACK FOOTER //
// ./src/components/aboutus.js